import React from 'react';
import styled from 'styled-components';
import BSFormCheck from 'react-bootstrap/FormCheck';

const RadioGroupWrapper = styled.div`
    & > label {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #202428;
        margin-bottom: 10px;
    }
`

const RadiosWrapper = styled.div`
    display: flex;
    align-content: center;
    height: calc(1.5em + 0.75rem + 2px);
    & > .form-check:first-child {
        padding-left: 0;
    }
`

interface RadioFieldProps {
    id?: string
    label: string
}

const RadioGroup: React.FC<RadioFieldProps> = ({ id, label, children }) => {
    return (
        <RadioGroupWrapper>
            <BSFormCheck.Label htmlFor={id}>{label}</BSFormCheck.Label>
            <RadiosWrapper>{children}</RadiosWrapper>
        </RadioGroupWrapper>
    )
}

export default RadioGroup
